import { FC } from 'react';

import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'core';
import { selectUser, setAfterLoginState } from 'store/user/userSlice';
import { useAppDispatch, useAppSelector } from 'store';

import { Button } from '@britishcouncil/react-solas';
import { LinkButton, Modal } from '@britishcouncil/react-solas-ors3';
import { OidcContext } from '@britishcouncil/react-oidc-auth';

export const LoginModal: FC<{ show: boolean; onExit: () => void }> = ({ show, onExit }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const loggedUser = useAppSelector(selectUser);
  const userManager = OidcContext.useAuth();

  const handleLoginClick = () => {
    if (loggedUser) {
      dispatch(setAfterLoginState('login'));
      userManager.signoutRedirect();
    } else {
      userManager.signinRedirect();
    }
  };

  const handleSignUpClick = () => {
    if (loggedUser) {
      dispatch(setAfterLoginState('signup'));
      userManager.signoutRedirect();
    } else {
      navigate(ROUTES.SIGN_IN);
    }
  };

  return (
    <Modal
      show={show}
      title={loggedUser ? 'You must relogin' : 'Authentication required'}
      onExit={onExit}
      footer={
        <Container>
          <p>If you don't have an account you can create one by clicking the link below.</p>
          <LinkButton onClick={handleSignUpClick}>Sign up</LinkButton>
        </Container>
      }
    >
      <Container>
        <Button intent="primary" onClick={handleLoginClick}>
          Log in
        </Button>
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  text-align: center;
  max-width: 450px;
  p {
    text-align: left;
  }
  .btn {
    width: 100%;
  }

  .btn-link {
    text-decoration: none;
  }
`;
